import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { each } from 'lodash'
import Menu from './backOffice/Menu'
import LoadingScreen from './LoadingScreen'
import AddPartner from './backOffice/AddPartner.js'
import Whitelist from './backOffice/Whitelist'
import GenericDomains from './backOffice/GenericDomains'
import Handouts from './backOffice/Handouts'
import AssignedViolations from './backOffice/violations/AssignedViolations'
import ContactEnrichment from './backOffice/violations/ContactEnrichment.js'
import ContactActions from './backOffice/contactActions/ContactActions'
import ScreenshotReview from './backOffice/violations/ScreenshotReview'
import ViolationPage from './backOffice/violations/ViolationPage'
import Users from './backOffice/users/Users'
import Statistics from './backOffice/statistics/Statistics'
import { Route, withRouter } from 'react-router-dom'
import { getModel } from './data/Model.js'
import getMe from './getMe'
import Redirect from 'react-router-dom/Redirect'
import { getSelectedClients } from './data/interactions'
import Settings from './backOffice/Settings'
import FilterSettings from './backOffice/filterSettings/FilterSettings'
import MyUser from './backOffice/MyUser'
import Export from './backOffice/export/Export'
import UploadReport from './backOffice/UploadReport'
import ImageUrlsBlacklist from './backOffice/BlacklistAndImageUrlsBlacklist'
import assignClientToUser from './backOffice/assignClientToUser.js'
import RegistrationCertificatesPage from './backOffice/registrationCertificates'
import PricingPage from './backOffice/pricing'
import Images from './backOffice/images/Images'
import SeshatLookup from './backOffice/seshat/SeshatLookup'
import { takePostLoginRedirect } from './postLoginRedirect'

class App extends Component {
	constructor(props) {
		super(props)
		this.state = {
			clientIdHasBeenProcessed: false,
		}
	}

	render() {
		const Model = getModel()
		const client_ids = getSelectedClients().map((client) => client.client_id)
		const client = getSelectedClients()[0]

		this.updateBodyClasses(Model)

		return (
			<div id='content' className='fadein'>
				<Menu />
				{Model.me.status.handle === 'loading' && (
					<LoadingScreen title={this.context.gettext('global.loading')} />
				)}
				{Model.me.status.handle === 'loaded' &&
					Model.me.data.clients.length === 0 && <AddPartner />}
				{Model.me.status.handle === 'loaded' &&
					Model.me.data.clients.length !== 0 && (
						<div style={{ paddingBottom: '50px' }}>
							<Route key='root' exact path='/' component={RootPageSelected} />
							<Route
								key='reports'
								exact
								path='/reports'
								render={() => <UploadReport />}
							/>
							<Route
								key='assigned-violations'
								exact
								path='/assigned-violations'
								render={() => <AssignedViolations client_ids={client_ids} />}
							/>
							<Route
								key='contact-enrichment'
								exact
								path='/contact-enrichment'
								render={() => <ContactEnrichment client_ids={client_ids} />}
							/>
							<Route
								key='contact-actions'
								exact
								path='/contact-actions'
								component={ContactActions}
							/>
							<Route
								key='screenshot-review'
								exact
								path='/screenshot-review'
								component={ScreenshotReview}
							/>
							<Route
								key='violation'
								exact
								path='/violation/:violationId'
								component={ViolationPage}
							/>
							<Route
								key='statistics'
								exact
								path='/statistics'
								component={Statistics}
							/>
							<Route
								key='users'
								exact
								path='/users'
								render={() => <Users client_ids={client_ids} />}
							/>
							{Model.me.data && (
								<Route
									key='my-user'
									exact
									path='/my-user'
									render={() => (
										<MyUser
											userId={Model.me.data.user_id}
											userName={`${Model.me.data.firstname} ${Model.me.data.lastname}`}
											userEmail={Model.me.data.email}
										/>
									)}
								/>
							)}
							<Route
								key='whitelist'
								exact
								path='/whitelist'
								render={() => <Whitelist client_ids={client_ids} />}
							/>
							<Route
								key='image-url-blacklist'
								exact
								path='/image-url-blacklist'
								render={() => <ImageUrlsBlacklist client_ids={client_ids} />}
							/>
							<Route
								key='generic-domains'
								exact
								path='/generic-domains'
								component={GenericDomains}
							/>
							<Route
								key='handouts'
								exact
								path='/handouts'
								render={() => <Handouts client_ids={client_ids} />}
							/>
							<Route
								key='add-partner'
								exact
								path='/add-partner'
								render={() => <AddPartner userId={Model.me.data.user_id} />}
							/>
							<Route key='settings' path='/settings' component={Settings} />
							<Route
								key='filter-settings'
								path='/filter-settings'
								render={() => <FilterSettings clientId={client.client_id} />}
							/>
							<Route key='export' path='/export' component={Export} />
							<Route
								key='registration-certificates'
								path='/registration-certificates'
								component={RegistrationCertificatesPage}
							/>
							<Route key='pricing' path='/pricing' component={PricingPage} />
							<Route
								key='images'
								path='/images'
								render={() => <Images client_ids={client_ids} />}
							/>
							<Route
								key='seshat-lookup'
								exact
								path='/seshat-lookup'
								component={SeshatLookup}
							/>
						</div>
					)}
			</div>
		)
	}

	componentDidMount = () => {
		if (getModel().me.status.handle === 'not-loaded') getMe()

		const postLoginRedirect = takePostLoginRedirect()
		if (postLoginRedirect) {
			this.props.history.replace(postLoginRedirect)
		}
	}

	async componentDidUpdate() {
		const Model = getModel()
		// User data is loaded AND we haven't processed the client_id yet
		if (Model.me.data.user_id && !this.state.clientIdHasBeenProcessed) {
			this.setState({ clientIdHasBeenProcessed: true })
			const params = new URLSearchParams(window.location.search)
			const clientId = params.get('client_id')
			if (clientId) {
				try {
					await assignClientToUser(Model.me.data.user_id, clientId)
					this.removeClientIdFromUrl()
				} catch (error) {
					console.error('Failed to assign client to user:', error)
				}
			}
		}
	}

	removeClientIdFromUrl = () => {
		const { history, location } = this.props
		const params = new URLSearchParams(location.search)
		params.delete('client_id')
		history.replace({
			pathname: location.pathname,
			search: params.toString(),
		})
	}

	updateBodyClasses = (model) => {
		const classesByLevel = {
			agent: 'role--agent',
			customer: 'role--customer',
			admin: 'role--admin',
		}

		const level = model.me.data.permission_level || 'admin'
		const classToAdd = classesByLevel[level] || ''

		each(Object.values(classesByLevel), (cls) => {
			if (cls !== classToAdd) {
				document.body.classList.remove(cls)
			}
		})

		document.body.classList.add(classToAdd)
	}
}

const RootPageSelected = () => {
	return <Redirect to={'/seshat-lookup'} />
}

App.contextTypes = {
	gettext: PropTypes.func.isRequired,
}

export default withRouter(App)
